import { Link } from "react-router-dom";
import { Reveal, Divider, Overline } from "@/components/layout/Atoms";
import { Heart, Briefcase, Cake, Wine, Truck, Sparkles, ArrowRight } from "lucide-react";
import { useContent } from "@/contexts/ContentContext";
import { resolveMediaUrl } from "@/lib/api";

const ICONS = { heart: Heart, briefcase: Briefcase, cake: Cake, wine: Wine, truck: Truck, sparkles: Sparkles };

export default function Services() {
    const c = useContent();
    const sv = c.services;

    return (
        <div data-testid="page-services">
            <section className="container-k pt-10 pb-20">
                <div className="max-w-3xl">
                    <Overline>{sv.hero.overline}</Overline>
                    <h1 className="mt-4 font-heading font-light text-5xl md:text-7xl leading-[1.0] text-kayama-ink">
                        {sv.hero.h1_part1} <span className="italic text-kayama-pink">{sv.hero.h1_italic}</span>{sv.hero.h1_part2}
                    </h1>
                    <p className="mt-6 text-kayama-brown-2 text-lg max-w-2xl">{sv.hero.subtitle}</p>
                </div>
            </section>

            {sv.items.map((s, i) => {
                const Icon = ICONS[s.icon] || Heart;
                return (
                    <section key={i} className="container-k py-16 md:py-24" data-testid={`service-${i}`}>
                        <div className={`grid lg:grid-cols-12 gap-12 items-center ${i % 2 === 1 ? "lg:[direction:rtl]" : ""}`}>
                            <Reveal className="lg:col-span-6 [direction:ltr]">
                                <img src={resolveMediaUrl(s.image)} alt={s.title} className="w-full h-[480px] md:h-[560px] object-cover" />
                            </Reveal>
                            <div className="lg:col-span-6 [direction:ltr]">
                                <div className="flex items-center gap-3 text-kayama-pink">
                                    <Icon size={22} />
                                    <Overline className="text-kayama-pink">0{i + 1} · Prestation</Overline>
                                </div>
                                <h2 className="mt-4 font-heading text-4xl md:text-5xl font-light text-kayama-brown leading-tight">{s.title}</h2>
                                <p className="script text-3xl md:text-4xl mt-3">{s.sub}</p>
                                <p className="mt-6 text-kayama-brown-2 leading-relaxed text-lg">{s.text}</p>
                                <ul className="mt-8 grid grid-cols-2 gap-4">
                                    {s.bullets.map((b, j) => (
                                        <li key={j} className="flex items-center gap-3 text-sm text-kayama-brown">
                                            <span className="w-6 h-px bg-kayama-gold" />{b}
                                        </li>
                                    ))}
                                </ul>
                                <Link to="/contact" className="btn-primary-k mt-10" data-testid={`service-${i}-cta`}>
                                    Demander un devis <ArrowRight size={16} />
                                </Link>
                            </div>
                        </div>
                    </section>
                );
            })}

            <section className="bg-kayama-muted py-24">
                <div className="container-k">
                    <div className="text-center max-w-2xl mx-auto">
                        <Overline>{sv.extras_overline}</Overline>
                        <h2 className="mt-4 font-heading text-4xl md:text-5xl font-light text-kayama-brown">{sv.extras_title}</h2>
                    </div>
                    <Divider />
                    <div className="grid md:grid-cols-3 gap-8 mt-8">
                        {sv.extras.map((e, i) => {
                            const Icon = ICONS[e.icon] || Sparkles;
                            return (
                                <div key={i} className="bg-kayama-paper p-8 border border-kayama-line text-center">
                                    <Icon className="text-kayama-pink mx-auto" size={28} />
                                    <h3 className="mt-4 font-heading text-2xl text-kayama-brown">{e.t}</h3>
                                    <p className="mt-3 text-sm text-kayama-brown-2 leading-relaxed">{e.d}</p>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>
        </div>
    );
}
